import CommonDelete from "@/components/common/Delete";
import { singleProp } from "@/interface/dataInterface";
import { FC } from "react";

const ClientDelete: FC<singleProp> = ({prop}) => (
    <CommonDelete id={prop} resource="auto-service/clients" />
) 

export default ClientDelete